/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import NProgress from 'nprogress'
import MealListView from '../../view/pages/meal/ListView'
import MealAction from '../../action/meal'
import MealsStore from '../../store/meal/MealsStore'
import MealPaginationStore from '../../store/meal/MealPaginationStore'

class ListContainer extends Component {
  static getStores() {
    return [MealsStore, MealPaginationStore]
  }

  static calculateState(prevState, props) {
    return {
      meals: MealsStore.getState(),
      pagination: MealPaginationStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()

    await MealAction.onSearch(this.state.pagination)
    NProgress.done()
  }

  render() {
    return MealListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
